import { render, staticRenderFns } from "./AddAttachmentsModal.vue?vue&type=template&id=e65fa2fc"
import script from "../../partials/contract/AddAttachmentsModal.js?vue&type=script&lang=js&external"
export * from "../../partials/contract/AddAttachmentsModal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports